module.exports = __webpack_public_path__ + "img/74c6514b8fd3e220e61ce6767345adc7.svg";